<template>
  <div class="matrix-select-choice">
    <matrix-table :columns="issue.items" :rows="issue.rows">
      <template v-slot:content="{ row, col }">
        <div v-for="(col, index) of issue.items" :key="col.id" class="mb-2 last:mb-0">
          <div class="rich-text-wrap my-1" v-html="col.content.richText"></div>
          <matrix-select-content :option="issue.getCellByRowAndCol(row, col)" />
        </div>
      </template>
    </matrix-table>
  </div>
</template>

<script>
import MatrixTable from '@/questions/components/MatrixForm'
import MatrixSelectContent from '@/questions/components/MatrixSelectContent'

export default {
  name: 'MatrixSelectChoice',
  components: { MatrixSelectContent, MatrixTable },
  changeExpr: 'selectAllIds',
  computed: {
    selectAllIds() {
      return this.issue.options.map(item => item.value)
    }
  },
  created() {
    console.log('MatrixSelectChoice')
  }
}
</script>

<style scoped></style>
